import React from 'react';
import { AppRegistry } from 'react-native';
import { JDNetwork } from '@jdreact/jdreact-core-lib'
import fetchJsonp from '@jdreact/jdreact-core-web/Libraries/Fetch/Jsonp';
// 引入web端轮播图需要的js和css
import Swiper from './JDReactSHHouse/components/thirdScript/web/swiper.min.js';
import './JDReactSHHouse/components/thirdScript/web/swiper.min.css';

window.Swiper = Swiper;

import App from './JDReactSHHouse/App'

// 配置网络请求接口，目前网关接口可以通过jsonp方式调用
var host = '//api.m.jd.com';
if ((/^beta-/gi).test(location.host) || (/\.care$/gi).test(location.host) || (/localhost/).test(location.host)) {
  host = '//beta-api.m.jd.com'
}
JDNetwork.setFetchProxy(function(functionId, params) {
  return fetchJsonp(`${host}/api?appid=house-data&functionId=${functionId}&body=${encodeURIComponent(params)}&client=ld&clientVersion=1.0.0`, {
    jsonpCallback: 'jsonp'
  })
});
// JDNetwork.setFetchProxy(function(functionId, params) {
// 	return fetchJsonp(`${host}/client.action?functionId=${functionId}&body=${encodeURIComponent(params)}&client=ld&clientVersion=1.0.0`, {
// 		jsonpCallback: 'jsonp'
// 	});
// });

AppRegistry.registerComponent('JDReactSHHouse', () => App);

function isLargeScreen () {
  var minWidth = 750
  var isWideScreen = window.matchMedia('(min-width: '+minWidth+'px)').matches
  // 检测 iPad
  var isIPad = /iPad/.test(navigator.userAgent)
  // 检测 Android 平板
  var isAndroidTablet = /Android/.test(navigator.userAgent) && !/Mobile/.test(navigator.userAgent)
  // 检测 iOS
  var isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
  // 检测 Android
  var isAndroid = /Android/.test(navigator.userAgent)
  return isWideScreen || isIPad || isAndroidTablet || (isIOS && isWideScreen) || (isAndroid && isWideScreen)
}

var baseNum = isLargeScreen() ? 14.4 : 7.5;

var oHtml = document.getElementsByTagName('html')[0];
var width_screen = document.documentElement.clientWidth || window.screen.width;
var realFontSize = Math.min(Math.max(10, width_screen / baseNum), 60);
oHtml.style.fontSize = realFontSize + "px";
var windowHeight = window.innerHeight;
window.onresize = function(){
	if(window.innerHeight-50>windowHeight){
		windowHeight = window.innerHeight;
	}
	width_screen=document.documentElement.clientWidth || window.screen.width;
  baseNum = isLargeScreen() ? 14.4 : 7.5;
  realFontSize = Math.min(Math.max(10, width_screen / baseNum), 60);
	oHtml.style.fontSize = realFontSize + "px";
}

var app = document.getElementById('m_common_content');
if (!app) {
  app = document.createElement('div');
  document.body.appendChild(app);
}

AppRegistry.runApplication('JDReactSHHouse', {
    rootTag: app
});